// extracted by mini-css-extract-plugin
export default {"container":"cat_card_container__BtpAW","img_container":"cat_card_img_container__tgsRV","title1":"cat_card_title1__0PylO","title2":"cat_card_title2__rpbRK"};